import type { SVGProps } from 'react';

const SvgPiPexitFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V11H4V18H20V6H11V4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM17.075 16.5L18.5 15.075L15.4 12H18V10H12V16H14V13.425L17.075 16.5ZM2 9V4H9V9H2Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgPiPexitFilled;
